bam-news-filter {
  bal-field {
    width: 100%;
  }
}